/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI73394ResRecordsItemActionsItem {
  
  /**  */
  label?: string;
  
  /**  */
  value?: string;
  
  /**  */
  isSelect?: number;
  
};
    
  
    
export interface IAPI73394ResRecordsItem {
  
  /**  */
  id?: string;
  
  /**  */
  sendTime?: string;
  
  /**  */
  content?: string;
  
  /**  */
  source?: string;
  
  /** ActionResp */
  actions?: IAPI73394ResRecordsItemActionsItem[];
  
};
    
  



export interface API73394Req {
  
  /** 会话id */
  sessionToken: string;
  /** 选项值 */
  action?: string;
  /** 上一条聊天记录Id */
  lastRecordId: string;
  /** 回复聊天记录值 */
  message: string;
};



export interface API73394Res {
  /** 会话标识Id  */
  sessionToken?: string;
  /** 会话记录 ,ChatRecordResp  */
  records?: IAPI73394ResRecordsItem[];
  
};


// 接口函数 73394 /chat/record/send

export interface IUsePostAPI73394Return {
  /** /chat/record/send: 接口请求状态 */
  isAPI73394Loading: boolean;
  /** /chat/record/send: 接口请求返回数据 */
  dataAPI73394: API73394Res;
  /**  /chat/record/send: 接口数据请求方法 */
  fetchAPI73394Data: (inputs: API73394Req, config?: YWRequestConfig) => Promise<API73394Res>;
  /** /chat/record/send: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI73394 = ():IUsePostAPI73394Return => {
  let isMount = true;
  const [isAPI73394Loading, setIsAPI73394Loading] = useState(false);
  const [dataAPI73394, setDataAPI73394] = useState<API73394Res>({} as API73394Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/record/send`;

  const fetchAPI73394Data = async (inputs: API73394Req, config?: YWRequestConfig): Promise<API73394Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API73394Req>) || {}) as API73394Req;
    
  
    if ( isMount ) {
      setIsAPI73394Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API73394Res>(`${basePath}/yoaichat-web/chat/record/send`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI73394(res || {} as API73394Res);
        setIsAPI73394Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI73394Loading(false);
      }
      return false as unknown as API73394Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI73394Loading,
    dataAPI73394,
    fetchAPI73394Data,
    requestUrl,
  }
}

